var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhoneIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none",
  viewBox: "0 0 18 18",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#51A196",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M16.5 12.69v2.25a1.5 1.5 0 0 1-1.635 1.5 14.84 14.84 0 0 1-6.472-2.302 14.6 14.6 0 0 1-4.5-4.5A14.84 14.84 0 0 1 1.59 3.135 1.5 1.5 0 0 1 3.083 1.5h2.25a1.5 1.5 0 0 1 1.5 1.29 9.6 9.6 0 0 0 .525 2.108A1.5 1.5 0 0 1 7.02 6.48l-.952.953a12 12 0 0 0 4.5 4.5l.952-.953a1.5 1.5 0 0 1 1.583-.337c.68.253 1.387.43 2.107.525a1.5 1.5 0 0 1 1.29 1.522"
})));
export { SvgPhoneIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/phoneIcon.svg";